import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material'
import { TokenAmount, useAsyncEffect } from '@xylabs/sdk-react'
import { Quadkey, XyoWorldAuction, XyoWorldMinter } from '@xyo-network/sdk-xyoworld-js'
import BigNumber from 'bn.js'
import { useContext, useState } from 'react'
import { Link } from 'react-router-dom'

import { QuadkeyMap } from '../../Components'
import { MinterAuctionContext, useMinter } from '../../Contexts'

const getChildrenForSale = (minter: XyoWorldMinter, auction: XyoWorldAuction) => {
  let childrenForSale: XyoWorldAuction[] = []
  if (auction.static.minted || auction.quadkey.toBase4HashLabel() === Quadkey.root.toBase4HashLabel()) {
    for (const quadkey of auction.quadkey.children()) {
      const childAuction = minter.auctions().get(quadkey)
      childrenForSale = childrenForSale.concat(getChildrenForSale(minter, childAuction))
    }
  } else {
    childrenForSale.push(auction)
  }
  return childrenForSale
}

interface QuadkeyStatsProps {
  quadkey: Quadkey
}

const QuadkeyStats: React.FC<QuadkeyStatsProps> = (props) => {
  const { minter } = useMinter()
  const { quadkey } = props

  const auction = minter?.auctions()?.get(quadkey)

  const [childrenForSale, setChildrenForSale] = useState<number>()
  const [avgPrice, setAvgPrice] = useState<BigNumber>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (minter && auction) {
        const childrenForSale = getChildrenForSale(minter, auction)
        const pricePromises = childrenForSale.map((auction) => {
          return auction.getCurrentBid()
        })
        const prices = await Promise.all(pricePromises)
        if (isMounted()) {
          if (prices.length > 0) {
            let totalPrice = new BigNumber(0)
            for (const price of prices) {
              totalPrice = totalPrice.add(price)
            }
            setAvgPrice(totalPrice.divn(prices.length))
            setChildrenForSale(prices.length)
          }
        }
      }
    },
    [auction, minter],
  )

  return (
    <Paper style={{ opacity: 0.7 }}>
      {childrenForSale && avgPrice ? (
        <Box display="flex" flexDirection="column" padding={1}>
          <Box alignItems="center" display="flex" justifyContent="center" paddingBottom={1}>
            <Typography variant="caption">{childrenForSale}</Typography>
          </Box>
          <Box alignItems="center" display="flex" justifyContent="center">
            <TokenAmount amount={avgPrice} />
          </Box>
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" padding={2}>
          <CircularProgress size={24} />
        </Box>
      )}
    </Paper>
  )
}

const QuadView: React.FC = () => {
  const { quadkey } = useContext(MinterAuctionContext)
  const childQuadkeys = quadkey?.children()

  const size = '40vmin'

  if (childQuadkeys) {
    return (
      <Box alignItems="center" display="flex" flexDirection="column" justifyContent="center">
        <Box display="flex" flexDirection="row">
          <Button component={Link} to={`/quadkey/${childQuadkeys[0].toBase4HashLabel()}`}>
            <Box height={size} justifyContent="center" margin="2px" width={size}>
              <QuadkeyMap crop={true} imgSize={size} quadkey={childQuadkeys[0]} size={512} />
            </Box>
            <Box display="flex" position="absolute">
              <QuadkeyStats quadkey={childQuadkeys[0]} />
            </Box>
          </Button>
          <Button component={Link} to={`/quadkey/${childQuadkeys[1].toBase4HashLabel()}`}>
            <Box height={size} justifyContent="center" margin="2px" width={size}>
              <QuadkeyMap crop={true} imgSize={size} quadkey={childQuadkeys[1]} size={512} />
            </Box>
            <Box display="flex" position="absolute">
              <QuadkeyStats quadkey={childQuadkeys[1]} />
            </Box>
          </Button>
        </Box>
        <Box display="flex" flexDirection="row">
          <Button component={Link} to={`/quadkey/${childQuadkeys[2].toBase4HashLabel()}`}>
            <Box height={size} justifyContent="center" margin="2px" width={size}>
              <QuadkeyMap crop={true} imgSize={size} quadkey={childQuadkeys[2]} size={512} />
            </Box>
            <Box display="flex" position="absolute">
              <QuadkeyStats quadkey={childQuadkeys[2]} />
            </Box>
          </Button>
          <Button component={Link} to={`/quadkey/${childQuadkeys[3].toBase4HashLabel()}`}>
            <Box height={size} justifyContent="center" margin="2px" width={size}>
              <QuadkeyMap crop={true} imgSize={size} quadkey={childQuadkeys[3]} size={512} />
            </Box>
            <Box display="flex" position="absolute">
              <QuadkeyStats quadkey={childQuadkeys[3]} />
            </Box>
          </Button>
        </Box>
      </Box>
    )
  }
  return null
}

export default QuadView
